import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { faqData } from '../mockData_extended';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const { language } = useLanguage();
  const content = faqData[language] || faqData.en;
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-light text-slate-800 mb-12 text-center">
          {content.title}
        </h2>

        <div className="space-y-4">
          {content.questions.map((item, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-xl overflow-hidden border border-slate-200 hover:border-[#d4845f] transition-all duration-300"
            >
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-slate-100 transition-colors"
              >
                <span className="text-lg font-semibold text-slate-800 pr-4">
                  {item.q}
                </span>
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-[#d4845f] flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-slate-400 flex-shrink-0" />
                )}
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6 text-slate-600 leading-relaxed">
                  {item.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
